import CalendarPublishingError from '../store/schema/CalendarPublishingError';
import PublishingPermissionItemState from '../store/schema/PublishingPermissionItemState';
import { action } from 'satcheljs';
import datapoints from '../datapoints';

// This action is listened by both orchestrator and mutator and takes folderId
export let loadCalendarPublishingPermissions = action(
    'loadCalendarPublishingPermissions',
    (folderId: string, calendarId: string, calendarHexColor: string, calendarTitle: string) => ({
        folderId,
        calendarId,
        calendarHexColor,
        calendarTitle,
        datapointConfig: {
            name: 'LoadCalendarPublishingPermissions',
            customData: { CalendarId: folderId },
        },
    })
);

export let initializeCalendarPublishingPermissionStore = action(
    'initializeCalendarPublishingPermissionStore'
);

// Mutator listens for this action to set store with publish permissions
export let saveCalendarPublishingPermissions = action(
    'saveCalendarPublishingPermissions',
    (
        publishingPermissionItemStates: PublishingPermissionItemState[],
        folderId: string,
        calName: string,
        primaryColor: string
    ) => ({
        publishingPermissionItemStates,
        folderId,
        calName,
        primaryColor,
    })
);

// Mutator listens for this action to set store with publish permission item state
export let updatePublishSelectedCalendar = action(
    'updatePublishSelectedCalendar',
    (selectedPublishingItemState: PublishingPermissionItemState) => ({
        selectedPublishingItemState,
    })
);

export let createNewCalendarPublishingPermission = action(
    'createNewCalendarPublishingPermission',
    (folderId: string, detailLevel?: string) => ({
        folderId,
        detailLevel,
        datapointConfig: {
            name: datapoints.CalendarPublishingCreateNewPermission.datapoint.name,
            customData: datapoints.CalendarPublishingCreateNewPermission.datapoint.customData(
                detailLevel
            ),
        },
    })
);

export let resetCalendarPublishingPermissionLinks = action(
    'resetCalendarPublishingPermissionLinks',
    (folderId: string, detailLevel: string) => ({
        folderId,
        detailLevel,
        datapointConfig: {
            name: datapoints.CalendarPublishingResetLinks.datapoint.name,
        },
    })
);

// Update selected publish permission in store for the drop down option
export let updateSelectedPublishingPermission = action(
    'updateSelectedPublishingPermission',
    (ddValue: string) => ({
        ddValue,
    })
);

// Unpublish a publish permission from the unpublish button
export let unpublishPublishedCalendar = action(
    'updateSelectedPublishingPermission',
    (folderId: string, detailLevel: string) => ({
        folderId,
        detailLevel,
        datapointConfig: {
            name: datapoints.CalendarPublishingUnpublish.datapoint.name,
        },
    })
);

/**
 * Busy/Loading state setting actions
 */

// Action for mutator to set isCreatePublishingPermissionPending for spinner.
export let setCreatePublishingPermissionPending = action(
    'setCreatePublishingPermissionPending',
    (isCreatePublishingPermissionPending: boolean) => ({
        isCreatePublishingPermissionPending,
    })
);

export let setInitialPublishPermissionsPending = action(
    'setInitialPublishPermissionsPending',
    (isPending: boolean) => ({
        isPending,
    })
);

export let setUnpublishPending = action(
    'setUnpublishPending',
    (folderId: string, detailLevel: string, isPending: boolean) => ({
        folderId,
        detailLevel,
        isPending,
    })
);

export let setLinkResetPending = action(
    'setLinkResetPending',
    (folderId: string, detailLevel: string, isPending: boolean) => ({
        folderId,
        detailLevel,
        isPending,
    })
);

/**
 * Error state setting actions
 */

export let setCalendarPublishingCalendarError = action(
    'setCalendarPublishingCalendarError',
    (folderId: string, error: CalendarPublishingError) => ({
        folderId,
        error,
    })
);

//Action for mutator to set initial load failure status
export let setCalendarPublishingErrorStateError = action(
    'setCalendarPublishingErrorStateError',
    (error: CalendarPublishingError) => ({
        error,
    })
);
